import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const SEO = ({
    titleEn,
    titlePl,
    descriptionEn,
    descriptionPl,
    keywords,
    image,
    url = 'https://www.unyamee.shop',
    type = 'website',
    schema
}) => {
    const { language } = useLanguage();
    const siteName = 'Unya Mee';

    const title = language === 'pl' ? titlePl || titleEn : titleEn;
    const description = language === 'pl' ? descriptionPl || descriptionEn : descriptionEn;
    const locale = language === 'pl' ? 'pl_PL' : 'en_US';

    const fullTitle = `${title} | ${siteName}`;
    const ogImage = image || 'https://www.unyamee.shop/images/workshops/main.jpg';

    return (
        <Helmet>
            {/* HTML Lang Attribute */}
            <html lang={language} />

            {/* Basic Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={url} />

            {/* Language Alternates */}
            <link rel="alternate" hrefLang="en" href={url} />
            <link rel="alternate" hrefLang="pl" href={url} />
            <link rel="alternate" hrefLang="x-default" href={url} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:url" content={url} />
            <meta property="og:locale" content={locale} />
            <meta property="og:locale:alternate" content={locale === 'pl_PL' ? 'en_US' : 'pl_PL'} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={title} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />

            {/* Local SEO / Geo Tags */}
            <meta name="geo.region" content="PL-MZ" />
            <meta name="geo.placename" content="Warsaw" />
            <meta name="geo.position" content="52.2297;21.0122" />
            <meta name="ICBM" content="52.2297, 21.0122" />

            {/* Structured Data (Schema.org) */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;

